import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import i18n from "@/plugins/i18n";
import veeValidatePlugin from "@/plugins/vee-validate";
import store from "@/plugins/store/store";
import { initHttpClient } from "@/services/http";

async function initApp() {
  await loadFonts();
  initHttpClient(store, router);

  const app = createApp(App)
    .use(router)
    .use(store)
    .use(vuetify)
    .use(i18n)
    .use(veeValidatePlugin);

  try {
    const isExpired = await store.dispatch("auth/checkExpiration");
    if (!isExpired && store.getters["auth/isAuthenticated"]) {
      await store.dispatch("auth/loadMyProfile");
    }
  } catch (e) {
    // ignore
  }

  app.mount("#app");
}

initApp();
